module.exports = __webpack_public_path__ + "search.svg?eed1765c67cb3ddf3721402e255bd31d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/search.svg
// module id = 368
// module chunks = 0